import React from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import {ValueFormatter} from '@epic-visualizations/charts';
import {getLocale} from '@epic-core/common';

import {dateFormatter} from '../../utils';
import {TIME_FORMAT} from '../../constants';
import Trend from '../../../../../trend/Trend';

import {Trends} from './types';
import {Releases} from '../../../../../../types';

const CODES = {
    releases: 'epic.affiliate.fortnite_games.releases',
    version: 'epic.affiliate.fortnite_games.version',
    previous: 'epic.affiliate.fortnite_games.releases.previous'
};

const StyledTooltipContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

const StyledTypography = styled(Typography)`
    color: ${p => p.theme.muiTheme.palette.dividerStrong};
`;

export interface PerformanceTooltipParams {
    trends?: Trends;
    releases?: Releases;
    tooltipFormatter: ValueFormatter<string | number>;
    getMessage: (code: string) => string;
}

const PerformanceTooltip = ({
    trends,
    releases,
    tooltipFormatter,
    getMessage
}: PerformanceTooltipParams) => {
    if (!trends) {
        return undefined;
    }

    return ({payload}: {payload: any}) => {
        const locale = getLocale();

        const {
            name,
            value,
            payload: {time}
        } = payload[0];

        const trend = trends[time] && trends[time][name];

        const tickReleases = releases[time];

        return (
            <React.Fragment key={name}>
                <StyledTooltipContainer>
                    <Typography noWrap variant="body1" component="span">
                        {tooltipFormatter ? tooltipFormatter(value) : Math.ceil(value)}
                    </Typography>
                    <Box mx={5}>
                        <Trend value={trend} />
                    </Box>
                </StyledTooltipContainer>
                {tickReleases && (
                    <Box my={2}>
                        <Divider />
                        <Box mt={2} mb={1}>
                            <Typography variant="caption" color="textSecondary">
                                {getMessage(CODES.releases)}
                            </Typography>
                        </Box>
                        {Object.values(tickReleases).map(({version, activated, displaced}) => (
                            <Box mb={1} key={`${version}${activated}`}>
                                {displaced ? (
                                    <StyledTypography noWrap variant="body1">
                                        {`${getMessage(CODES.version)}${version} - ${getMessage(
                                            CODES.previous
                                        )}`}
                                    </StyledTypography>
                                ) : (
                                    <Typography noWrap variant="body1">
                                        {`${getMessage(CODES.version)}${version} - ${dateFormatter(
                                            TIME_FORMAT
                                        )(locale)(activated)}`}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                    </Box>
                )}
            </React.Fragment>
        );
    };
};

export default PerformanceTooltip;
